import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getBuilderChartDataRequest } from '../../../../redux/actions';
import { SplitPane } from '../../../../components';
import { SimulatingChart } from '../../../../components/SimulatingChart';
import { SideMenu } from './SideMenu';
import { ChartSettings } from '../../../../components/ChartSettings';
import { Footer } from './Footer';
import styles from './configurationPage.module.scss';

export const ConfigurationPage = memo(() => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBuilderChartDataRequest());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <SideMenu />
      <div className={styles.detail}>
        <div className={styles.content}>
          <SplitPane split="horizontal" defaultSize="60%" minSize={200}>
            <SimulatingChart />
            <ChartSettings />
          </SplitPane>
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
});
